import { z } from 'zod';

export const subContractRegistrationSchema = z.object({
  target: z
    .date({ required_error: '도착 날짜 선택은 필수 입니다.' })
    .nullable(),
  content: z
    .string({ required_error: '내용 입력은 필수 입니다.' })
    .min(2, { message: '2자 이상 입력해주세요.' }),
});
